// @flow
import * as React from 'react';
import { GLOBAL_SPINNER } from './store/Constants';
import Spinner from './common/Spinner';

import './GlobalSpinner.css';
import Store from './store/Store';
import StoreDataChangeEvent from './store/StoreDataChangeEvent';

type Props = {};

type State = { showSpinner: boolean };

export default class GlobalSpinner extends React.PureComponent<Props, State> {
  _mounted: boolean;
  state = {
    showSpinner: false
  }
  componentDidMount(): void {
    Store.GLOBAL_STORE.subscribe(this.onGlobalSpinnerPropChange, GLOBAL_SPINNER);
    this._mounted = true;
  }

  componentWillUnmount(): void {
    this._mounted = false;
    Store.GLOBAL_STORE.unsubscribe(this.onGlobalSpinnerPropChange, GLOBAL_SPINNER)
  }
  
  onGlobalSpinnerPropChange = (e: StoreDataChangeEvent<boolean>): void => {
    this.setState({ showSpinner: !!e.getData() })
  }

  render() {
    if (this.state.showSpinner === false) {
      return null;
    }

    return (
      <div name="GlobalSpinner">
        <Spinner large />
      </div>
    );
  }
}
